import { createStore, applyMiddleware, compose } from 'redux'
//import { persistStore } from 'redux-persist'
import thunk from 'redux-thunk'
//import { createLogger } from 'redux-logger'
import { enableReduxDevTools } from 'lib/utils';
import { errorNotification } from './middlewares/notification'

// root reducer
import reducers from './reducers'

const initialState = {};

const composeEnhancers = enableReduxDevTools(['local', 'development', 'staging']) ?
	window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
		// Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
	}) : compose;

export const store = createStore(
	reducers,
	initialState,
	composeEnhancers(
		applyMiddleware(
			thunk,
			errorNotification
		),
	)
);

// begin periodically persisting the store
//persistStore(store);

export default store;


// WEBPACK FOOTER //
// ./src/redux/store.js